export enum AuthMethodKind {
  phone = 'phone',
  email = 'email',
  passkey = 'passkey',
}
